import React, { useState, useEffect, useRef } from "react";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import axios from "axios";
import { use } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Avatar,
  Button,
  Chip,
  TextField,
  Select,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Stack,
  Menu,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  Badge,
  Skeleton,
  Card,
  alpha,
  Divider,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@mui/material/styles";
import p2pWebSocketService from "./p2pWebSocketService";
import {
  decryptMessages,
  encryptMessages,
  P2PWEBSERVICE,
  showToast,
  WEBSERVICE,
} from "../../CoreDataService";
import EditIcon from "@mui/icons-material/Edit";
import { useChat } from "../../Services/ChatService";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DataTable from "../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";

const BuySellOrderTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { btncolor } = useSelector((state) => state);
  const themecolor = localStorage.getItem("theme");

  const [orderType, setOrderType] = useState("BUY");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("All Currencies");
  const [paymentMethod, setPaymentMethod] = useState("All Payment Methods");
  const [region, setRegion] = useState("All Regions");
  const [regionList, setRegionList] = useState([]);

  const [sortOrder, setSortOrder] = useState("0");
  const [selectedFiatCurrency, setSelectedFiatCurrency] = useState("USDT");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const websocketRef = useRef(null);
  const [ads, setAds] = useState([]);
  const [buyOrders, setBuyOrders] = useState([]);

  const [allCurrencies, setAllCurrencies] = useState([]);
  const [visibleCurrencies, setVisibleCurrencies] = useState(
    allCurrencies.slice(0, 6)
  );
  const [hiddenCurrencies, setHiddenCurrencies] = useState(
    allCurrencies.slice(6)
  );
  const [allFiatList, setAllFiatList] = useState([]);
  const [recordCount, setRecordCount] = useState(null);
  const [completionRate, setCompletionRate] = useState(null);
  const [paymentTimeLimit, setPaymentTimeLimit] = useState(null);
  const [minOrderLimit, setMinOrderLimit] = useState(null);
  const [maxOrderLimit, setMaxOrderLimit] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [price, setPrice] = useState(null);
  const [fiat, setFiat] = useState("");
  const [crypto, setCrypto] = useState("");
  const [paymentProviderName, setPaymentProviderName] = useState([]);
  const [availableAmount, setAvailableAmount] = useState(null);
  const [profileName, setProfileName] = useState("");
  const [adId, setAdId] = useState(null);
  const [counterPartyUuid, setCounterPartyUuid] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [sellAmount, setSellAmount] = useState(null);
  const [onlineStatus, setOnlineStatus] = useState(null);
  const [profilePic, setProfilePic] = useState("");
  const [profileImageLink, setProfileImageLink] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const [
    currentSelectedBankPaymentMethod,
    setCurrentSelectedBankPaymentMethod,
  ] = useState([]);
  const [selectedBankPaymentMethod, setSelectedBankPaymentMethod] = useState(
    []
  );
  const [
    currentSelectedWalletPaymentMethod,
    setCurrentSelectedWalletPaymentMethod,
  ] = useState([]);
  const [selectedWalletPaymentMethod, setSelectedWalletPaymentMethod] =
    useState([]);
  const [buyDialogOpen, setBuyDialogOpen] = useState(false);
  const [sellDialogOpen, setSellDialogOpen] = useState(false);
  const [walletAvailableBalance, setWalletAvailableBalance] = useState(0);
  const [modalPrice, setModalPrice] = useState(null);
  const [modalRemainingAmount, setModalRemainingAmount] = useState(null);
  const [payAmount, setPayAmount] = useState(null);
  const [receiveAmount, setReceiveAmount] = useState(null);
  const [bankTransferPaymentMethodList, setBankTransferPaymentMethodList] =
    useState([]);
  const [walletServicePaymentMethodList, setWalletServicePaymentMethodList] =
    useState([]);
  const [paymentEditModal, setPaymentEditModal] = useState(false);
  const [formValues, setFormValues] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [pmDetailsId, setPmDetailsId] = useState(null);
  const [editPaymentMethod, setEditPaymentMethod] = useState("");

  const [accountHolderNameEdit, setAccountHolderNameEdit] = useState("");
  const [paymentProviderNameEdit, setPaymentProviderNameEdit] = useState("");
  const [phoneNumberEdit, setPhoneNumberEdit] = useState("");
  const [walletIdEdit, setWalletIdEdit] = useState("");
  const [emailIdEdit, setEmailIdEdit] = useState("");

  const [accountNumberEdit, setAccountNumberEdit] = useState("");
  const [accountTypeEdit, setAccountTypeEdit] = useState("");
  const [identificationTypeEdit, setIdentificationTypeEdit] = useState("");
  const [routingNumberEdit, setRoutingNumberEdit] = useState("");
  const [bankNameEdit, setBankNameEdit] = useState("");
  const [bankAddressEdit, setBankAddressEdit] = useState("");

  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [bankIdentificationTypeOptions, setBankIdentificationTypeOptions] =
    useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [selectedCodeType, setSelectedCodeType] = useState("");
  const [adsloading, setAdsloading] = useState("");
  const [holdingInUsd, setHoldingInUsd] = useState(null);

  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
  } = useChat();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      accountHolder: "",
      ibanNumber: "",
      bankName: "",
      accountType: "",
      bankAddress: "",
      codeType: "",
      additionalCode: "",
    },
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleHiddenCurrencyClick = (selectedCurrency) => {
    const updatedVisible = [...visibleCurrencies];
    const updatedHidden = hiddenCurrencies.filter(
      (c) => c.currencyCode !== selectedCurrency.currencyCode
    );

    if (
      !updatedVisible.some(
        (c) => c.currencyCode === selectedCurrency.currencyCode
      )
    ) {
      if (updatedVisible.length >= 4) {
        const removed = updatedVisible.pop();
        updatedHidden.push(removed);
      }
      updatedVisible.push(selectedCurrency);
    }

    setVisibleCurrencies(updatedVisible);
    setHiddenCurrencies(updatedHidden);
    setSelectedFiatCurrency(selectedCurrency.currencyCode);
    setAnchorEl(null);
  };

  console.log("buyOrders", buyOrders);

  const handleSearch = () => {
    const initSocket = async () => {
      setAdsloading(true);
      await p2pWebSocketService.connect();
      p2pWebSocketService.subscribeToP2P();

      p2pWebSocketService.onMessage((msg) => {
        try {
          const data = JSON.parse(msg);
          console.log("ads", data);
          setBuyOrders(retrieveProfileImageBuy(data.adResponse || []));
          setAdsloading(false);
        } catch (err) {
          console.error("JSON parse error:", err);
          setAdsloading(false);
        }
      });

      p2pWebSocketService.subscribe(
        orderType,
        selectedFiatCurrency,
        amount,
        paymentMethod,
        sortOrder,
        region,
        currency,
        "1",
        "100"
      );
    };

    initSocket();
    getAllFiat();
    getAllRegion();
    getAllPaymentMethodByUser();

    const paymentMethods = ["Wallet Services", "Bank Transfer"];
    const accountTypes = [
      "Personal Savings",
      "Personal Checking",
      "Business Savings",
      "Business Checking",
    ];
    const bankIdTypes = ["ROUTING NO", "IFSC CODE", "SWIFT CODE"];

    setPaymentMethodOptions(paymentMethods);
    setAccountTypeOptions(accountTypes);
    setBankIdentificationTypeOptions(bankIdTypes);

    return () => {
      p2pWebSocketService.disconnect();
    };
  };

  const retrieveProfileImageBuy = (buyAdsData) => {
    return buyAdsData.map((ad) => {
      const firstLetter = ad.nickName?.charAt(0) || "";
      const profileImageLink = ad.profilePic
        ? `https://paybito-profilepic-usa.s3.us-west-1.amazonaws.com/${ad.uuid}/${ad.profilePic}`
        : "";

      return {
        ...ad,
        firstLetter,
        profileImageLink,
      };
    });
  };

  const handleReset = () => {
    setAmount("");
    setCurrency("All Currencies");
    setPaymentMethod("All Payment Methods");
    setRegion("All Regions");
    setSortOrder("0");
    setOrderType("BUY");
    setSelectedFiatCurrency("USDT");
  };

  useEffect(() => {
    console.log("onlineUsers", onlineUsers);
    modifyListForOnlineShow();
  }, [onlineUsers]);

  const modifyListForOnlineShow = () => {
    if (!Array.isArray(buyOrders)) {
      console.warn("buyOrders is not an array:", buyOrders);
      return;
    }

    const updatedOrders = buyOrders.map((ad) => {
      const isOnline = Array.isArray(onlineUsers)
        ? onlineUsers.some((user) => decryptMessages(user.userId) === ad.uuid)
        : false;

      return { ...ad, isOnline };
    });

    setBuyOrders(updatedOrders);
    console.log("Updated Orders with Online Status:", updatedOrders);
  };

  const checkOnlineUser = (targetUserId) => {
    return onlineUsers?.some(
      (user) => decryptMessages(user.userId) === targetUserId.toString()
    );
  };

  useEffect(() => {
    getCurrencyByAd();
    getAllFiat();
    getAllRegion();
    getAllPaymentMethodByUser();
    getUserTransactionBalanceRest();

    const paymentMethods = ["Wallet Services", "Bank Transfer"];
    const accountTypes = [
      "Personal Savings",
      "Personal Checking",
      "Business Savings",
      "Business Checking",
    ];
    const bankIdTypes = ["ROUTING NO", "IFSC CODE", "SWIFT CODE"];

    setPaymentMethodOptions(paymentMethods);
    setAccountTypeOptions(accountTypes);
    setBankIdentificationTypeOptions(bankIdTypes);
  }, []);

  useEffect(() => {
    const initSocket = async () => {
      setAdsloading(true);
      await p2pWebSocketService.connect();
      p2pWebSocketService.subscribeToP2P();

      p2pWebSocketService.onMessage((msg) => {
        try {
          const data = JSON.parse(msg);
          setBuyOrders(retrieveProfileImageBuy(data.adResponse || []));
          console.log("ads", data);
          setAdsloading(false);
        } catch (err) {
          console.error("JSON parse error:", err);
          setAdsloading(false);
        }
      });

      p2pWebSocketService.subscribe(
        orderType,
        selectedFiatCurrency,
        amount,
        paymentMethod,
        sortOrder,
        region,
        currency,
        "1",
        "100"
      );
    };

    initSocket();

    return () => {
      p2pWebSocketService.disconnect();
    };
  }, [orderType, selectedFiatCurrency]);

  console.log("buyOrders", buyOrders);

  const getAllPaymentMethodByUser = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllPaymentMethodByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const { error, error_msg, paymentDetails } = response.data;

      if (error?.error_data === 0 && Array.isArray(paymentDetails)) {
        const bankMethods = [];
        const walletMethods = [];

        paymentDetails.forEach((method) => {
          if (method.paymentMethodName === "BANK TRANSFER") {
            let identificationType = "";
            let identificationNumber = "";

            if (method.ifscCode) {
              identificationType = "IFSC CODE";
              identificationNumber = method.ifscCode;
            } else if (method.swiftCode) {
              identificationType = "SWIFT CODE";
              identificationNumber = method.swiftCode;
            } else if (method.routingNo) {
              identificationType = "ROUTING NO";
              identificationNumber = method.routingNo;
            }

            bankMethods.push({
              accountHolderName: method.profileName,
              bankName: method.bankName,
              pmDetailsId: method.pmDetailsId,
              accountNo: method.accountNo,
              accountType: method.accountType,
              identificationType,
              identificationNumber,
              bankAddress: method.bankAddress,
            });
          } else {
            walletMethods.push({
              paymentProviderName: method.paymentProviderName,
              walletId: method.vpa,
              pmDetailsId: method.pmDetailsId,
              email_id: method.emailId,
              phone_number: method.mobileNo,
              profileName: method.profileName,
            });
          }
        });

        console.log("BankTransferPaymentMethodList", bankTransferPaymentMethodList);
        console.log("walletTransferPaymentMethodList", walletServicePaymentMethodList);

        setBankTransferPaymentMethodList(bankMethods);
        setWalletServicePaymentMethodList(walletMethods);
      } else {
        showToast("error", error_msg || "Failed to fetch payment methods");
        setBankTransferPaymentMethodList([]);
        setWalletServicePaymentMethodList([]);
      }
    } catch (error) {
      showToast("error", "Something went wrong while fetching payment methods");
      setBankTransferPaymentMethodList([]);
      setWalletServicePaymentMethodList([]);
    }
  };

  const getCurrencyByAd = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getCurrencyByAd/${localStorage.getItem(
          "BROKERID"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const assetDetails = response.data.assetDetails || [];

      setAllCurrencies(assetDetails);
      setSelectedFiatCurrency(assetDetails[0]?.currencyCode || "");

      const visible = assetDetails.slice(0, 6);
      const hidden = assetDetails.slice(6);

      setVisibleCurrencies(visible);
      setHiddenCurrencies(hidden);
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const getAllFiat = async () => {
    try {
      const response = await axios.get(
        `https://v6.exchangerate-api.com/v6/780e118e654b80b4f67594ed/latest/USD`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      let newAllFiats = response.data.conversion_rates || [];
      console.log("fiats", newAllFiats);
      setAllFiatList(Object.keys(newAllFiats));
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const getAllRegion = async () => {
    try {
      const response = await axios.get(
        WEBSERVICE + `crypto/banking/p2p/getAllRegions`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      let regions = response.data.regions || [];
      setRegionList(regions);
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const getOrderCount = async (data) => {
    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getOrderCount`,
        JSON.stringify({ adId: Number(data.id) }),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data) {
        setRecordCount(response.data.recordCount);
        setCompletionRate(Number(response.data.completionRate).toFixed(2));
      }
    } catch (error) {
      console.error("Error fetching order count:", error);
    }
  };

  const reset = () => {
    setPaymentTimeLimit(null);
    setMinOrderLimit(null);
    setMaxOrderLimit(null);
    setRemarks("");
    setPrice(null);
    setFiat("");
    setCrypto("");
    setPaymentProviderName([]);
    setAvailableAmount(null);
    setProfileName("");
    setAdId(null);
    setCounterPartyUuid("");
    setOrderId(null);
    setSellAmount(null);
    setOnlineStatus(null);
    setProfilePic("");
    setProfileImageLink("");
    setFirstLetter("");
    setCurrentSelectedBankPaymentMethod([]);
    setSelectedBankPaymentMethod([]);
    setCurrentSelectedWalletPaymentMethod([]);
    setSelectedWalletPaymentMethod([]);
  };

  const buySellCrypto = (data) => {
    reset();
    getOrderCount(data);

    setPaymentTimeLimit(data.paymentTimeLimit);
    setMinOrderLimit(data.minOrderLimit);
    setMaxOrderLimit(data.maxOrderLimit);
    setRemarks(data.remarks);
    setPrice(data.priceType === "Floating" ? data.floatingPrice : data.price);
    setFiat(data.fiat);
    setCrypto(data.crypto);
    setPaymentProviderName(data.paymentProviderNames || []);
    setAvailableAmount(data.remainingAmount);
    setProfileName(data.nickName);
    setAdId(data.id);
    setCounterPartyUuid(data.uuid);
    setOrderId(data.pmDetailsId);
    setSellAmount(data.amount);
    setOnlineStatus(data.isOnline);
    setProfilePic(data.profilePic);
    setProfileImageLink(data.profileImageLink);
    setFirstLetter(data.firstLetter);
    setCurrentSelectedBankPaymentMethod([]);
    setSelectedBankPaymentMethod([]);
    setCurrentSelectedWalletPaymentMethod([]);
    setSelectedWalletPaymentMethod([]);
    setModalPrice(data.price);
    setModalRemainingAmount(data.remainingAmount);
    setSelectedWalletPaymentMethod([]);

    if (orderType === "BUY") {
      setBuyDialogOpen(true);
    } else {
      setSellDialogOpen(true);
    }

    getP2PBalance(data.crypto);
  };

  const getP2PBalance = async (asset) => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const payload = { uuid, assets: asset };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getP2PBalance`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const apiMessage = response.data.error;
      if (apiMessage == null) {
        const walletDetails = response.data.p2pWalletDetails;
        if (walletDetails && walletDetails.length > 0) {
          setWalletAvailableBalance(walletDetails[0].amount);
        } else {
          setWalletAvailableBalance(0);
        }
      } else {
        console.error("API Error:", apiMessage);
      }
    } catch (error) {
      console.error("Request Failed:", error);
    }
  };

  const handleBuyDialogClose = () => setBuyDialogOpen(false);
  const handleSellDialogClose = () => setSellDialogOpen(false);
  const handlePaymentEditDialogClose = () => setPaymentEditModal(false);

  function calculateTotalAmount(e) {
    setPayAmount(e);
    setReceiveAmount(e / parseFloat(price));
  }

  const addBankPaymentMethod = (i) => {
    const existingIndex = currentSelectedBankPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const bankDetails = bankTransferPaymentMethodList[i];

    console.log("bankDetails", bankDetails);

    if (existingIndex !== -1) {
      setCurrentSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== bankDetails.pmDetailsId)
      );
    } else {
      setCurrentSelectedBankPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedBankPaymentMethod((prev) => [
        ...prev,
        { pmDetailsId: bankDetails.pmDetailsId, bankName: bankDetails.bankName },
      ]);
    }
  };

  const addWalletPaymentMethod = (i) => {
    const existingIndex = currentSelectedWalletPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const walletDetails = walletServicePaymentMethodList[i];

    if (existingIndex !== -1) {
      setCurrentSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== walletDetails.pmDetailsId)
      );
    } else {
      setCurrentSelectedWalletPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedWalletPaymentMethod((prev) => [
        ...prev,
        {
          pmDetailsId: walletDetails.pmDetailsId,
          paymentProviderName: walletDetails.paymentProviderName,
        },
      ]);
    }
  };

  const handleBuySellSubmit = async (type) => {
    if (payAmount === "" || receiveAmount === "") {
      showToast("error", "Please enter some amount !!!");
      return;
    }
    var inputObj = {
      adType: orderType,
      crypto: crypto,
      fiat: fiat,
      amount: receiveAmount,
      amountPaidByUser: payAmount,
      totalAmount: availableAmount,
      paymentTimeLimit: paymentTimeLimit,
      uuid: localStorage.getItem("uuid"),
      counterPartyUuid: counterPartyUuid,
      confirm: 0,
      adId: adId,
      advertiserProfileName: profileName,
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    if (type === "BUY") {
      inputObj = inputObj;
      inputObj.price = price;
    } else {
      if (
        selectedWalletPaymentMethod.length === 0 &&
        selectedBankPaymentMethod.length === 0
      ) {
        showToast("error", "Please choose at least one payment method");
        return;
      }

      const allSelectedPaymentMethod = [
        ...selectedBankPaymentMethod.map((item) => item.bankName),
        ...selectedWalletPaymentMethod.map((item) => item.paymentProviderName),
      ];

      inputObj.pmList = allSelectedPaymentMethod;
      inputObj.pmList = allSelectedPaymentMethod;
      inputObj.price = price;
    }

    console.log("inputObj", inputObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/buySellOfferCreate`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const data = response.data;

      if (data.errorResponse.error_data === 0) {
        localStorage.setItem("previousAdId", adId);
        localStorage.setItem("previousOrderId", data.orderId);
        localStorage.setItem("orderCreationTime", data.createdDate);
        localStorage.setItem("counterPartyUuid", counterPartyUuid);
        localStorage.setItem("chatUserName", profileName);
        localStorage.setItem("orderfiat", fiat);
        localStorage.setItem("orderCrypto", crypto);
        localStorage.setItem("profilePic", profilePic);
        localStorage.setItem("profileImageLink", profileImageLink);
        localStorage.setItem("firstLetter", firstLetter);
        dispatch({ type: "SET_P2P_BuySellDetails", payload: data });
        if (type === "BUY") {
          localStorage.setItem("previousPageBuyAmount", receiveAmount);
          localStorage.setItem("previousPageBuyTotalAmount", payAmount);
          localStorage.setItem("previousPageBuyprice", price);
          handleBuyDialogClose(false);
        } else {
          localStorage.setItem("previousPageBuyAmount", price);
          localStorage.setItem("previousPageBuyTotalAmount", payAmount);
          localStorage.setItem("previousPageBuyprice", receiveAmount);
        }

        if (type === "BUY") {
          navigate("/p2p/order-details");
        } else {
          navigate("/p2p/sell-order-details");
        }
      } else {
        showToast("error", data.errorResponse.error_msg);
      }
    } catch (error) {
      showToast("error", "Something went wrong while creating order.");
      console.error(error);
    }
  };

  function calculateAmount(e) {
    setReceiveAmount(e);
    setPayAmount(parseFloat(price) * parseFloat(e));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleOpenEditPaymentModal = (pmDetailsId, index, service) => {
    if (service === "wallet_services") {
      setAccountHolderNameEdit(walletServicePaymentMethodList[index].profileName);
      setPaymentProviderNameEdit(walletServicePaymentMethodList[index].paymentProviderName);
      setPhoneNumberEdit(walletServicePaymentMethodList[index].phone_number);
      setWalletIdEdit(walletServicePaymentMethodList[index].walletId);
      setEmailIdEdit(walletServicePaymentMethodList[index].email_id);
      setEditPaymentMethod("Wallet Services");
    } else {
      setAccountHolderNameEdit(bankTransferPaymentMethodList[index].accountHolderName);
      setAccountNumberEdit(bankTransferPaymentMethodList[index].accountNo);
      setAccountTypeEdit(bankTransferPaymentMethodList[index].accountType);
      setIdentificationTypeEdit(bankTransferPaymentMethodList[index].identificationType);
      setRoutingNumberEdit(bankTransferPaymentMethodList[index].identificationNumber);
      setBankNameEdit(bankTransferPaymentMethodList[index].bankName);
      setBankAddressEdit(bankTransferPaymentMethodList[index].bankAddress);

      setValue("accountHolder", bankTransferPaymentMethodList[index].accountHolderName || "");
      setValue("ibanNumber", bankTransferPaymentMethodList[index].accountNo || "");
      setValue("bankName", bankTransferPaymentMethodList[index].bankName || "");
      setValue("accountType", bankTransferPaymentMethodList[index].accountType || "Personal Savings");
      setSelectedAccountType(bankTransferPaymentMethodList[index].accountType);
      setValue("bankAddress", bankTransferPaymentMethodList[index].bankAddress || "");
      setValue("codeType", bankTransferPaymentMethodList[index].identificationType);
      setSelectedCodeType(bankTransferPaymentMethodList[index].identificationType);
      setValue("additionalCode", bankTransferPaymentMethodList[index].identificationNumber);
      console.log("additionalCode", bankTransferPaymentMethodList[index].identificationNumber);

      setEditPaymentMethod("Bank Transfer");
    }

    setPmDetailsId(pmDetailsId);
    setPaymentEditModal(true);
  };

  const validateBankCode = (code) => {
    if (!code) return "Required";
    const type = watch("codeType");
    let reg;
    if (type === "ROUTING NO") {
      reg = /^\d{9}$/gm;
      return reg.test(code) ? true : "Invalid Routing Number (9 digits required)";
    } else if (type === "SWIFT CODE") {
      reg = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/gm;
      return reg.test(code) ? true : "Invalid SWIFT Code";
    } else if (type === "IFSC CODE") {
      reg = /^[A-Z]{4}0[A-Z0-9]{6}$/gm;
      return reg.test(code) ? true : "Invalid IFSC Code";
    }
    return "Invalid Code";
  };

  const updateBankDetails = async () => {
    const formValues = watch();
    console.log("formValues.accountType", formValues);

    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 2,
      paymentMethodName: "BANK TRANSFER",
      profileName: formValues.accountHolder,
      accountNo: formValues.ibanNumber,
      accountType: formValues.accountType,
      bankName: formValues.bankName,
      bankAddress: formValues.bankAddress,
      pmDetailsId: pmDetailsId,
    };

    switch (formValues.codeType) {
      case "ROUTING NO":
        payload.routingNo = formValues.additionalCode;
        break;
      case "IFSC CODE":
        payload.ifscCode = formValues.additionalCode;
        break;
      case "SWIFT CODE":
        payload.swiftCode = formValues.additionalCode;
        break;
      default:
        break;
    }

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          setPaymentEditModal(false);
          setPmDetailsId("");
          setAccountHolderNameEdit("");
          setAccountNumberEdit("");
          setAccountTypeEdit("");
          setIdentificationTypeEdit("");
          setRoutingNumberEdit("");
          setBankNameEdit("");
          setBankAddressEdit("");
          getAllPaymentMethodByUser();
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "An error occurred while updating the payment method");
      console.error("Update error:", error);
    }
  };

  const updateWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: accountHolderNameEdit,
      mobileNo: phoneNumberEdit,
      vpa: walletIdEdit,
      emailId: emailIdEdit,
      paymentProviderName: paymentProviderNameEdit,
      pmDetailsId: pmDetailsId,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          setPaymentEditModal(false);
          setPmDetailsId("");
          setPaymentProviderNameEdit("");
          setPhoneNumberEdit("");
          setWalletIdEdit("");
          setEmailIdEdit("");
          setAccountHolderNameEdit("");
          getAllPaymentMethodByUser();
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  const gotoPublicProfile = (data) => {
    localStorage.setItem("profilePic", data.profilePic);
    localStorage.setItem("profileImageLink", data.profileImageLink);
    localStorage.setItem("firstLetter", data.firstLetter);
    navigate(`/p2p/public-profile/${encryptMessages(data.uuid)}`);
  };

  const getUserTransactionBalanceRest = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const usdEntry = response.data.userBalanceList.find(
        (entry) => entry.currencyCode === "USDT"
      );
      console.log("usdEntry", usdEntry, usdEntry ? usdEntry.holdingInUsd : null);
      setHoldingInUsd(usdEntry ? usdEntry.holdingInUsd : null);
    } catch (error) {
      console.error("Error fetching user balance:", error);
    }
  };

  // Derived: activeTabIndex for Tabs component (0=BUY, 1=SELL)
  const activeTabIndex = orderType === "BUY" ? 0 : 1;

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          borderRadius: "18px",
          px: { xs: 3, md: 4 },
          py: { xs: 3, md: 3.5 },
          mb: 3,
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, position: "relative", zIndex: 1 }}>
          <Box
            sx={{
              width: 56, height: 56, borderRadius: "14px",
              display: "flex", alignItems: "center", justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.18)",
              border: "1px solid rgba(255,255,255,0.25)",
              backdropFilter: "blur(6px)", flexShrink: 0,
            }}
          >
            <CompareArrowsOutlinedIcon sx={{ fontSize: 30, color: "#fff" }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: { xs: "1.4rem", md: "1.7rem" }, fontWeight: 700, color: "#fff", lineHeight: 1.15, letterSpacing: "-0.015em" }}>
              P2P Trading
            </Typography>
            <Typography sx={{ fontSize: { xs: "0.82rem", md: "0.9rem" }, color: "rgba(255,255,255,0.88)", mt: 0.5 }}>
              Buy and sell crypto directly with other users
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>
      {/* ── Buy / Sell Tabs + Currency Selector ── */}
      <Box sx={tabsWrap}>
        <Tabs
          value={activeTabIndex}
          onChange={(_, v) => setOrderType(v === 0 ? "BUY" : "SELL")}
          sx={{
            ...tabsStyle,
            "& .MuiTabs-indicator": {
              backgroundColor: activeTabIndex === 0 ? "#16a34a" : "#ef4444",
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          <Tab
            iconPosition="start"
            icon={<TrendingUpOutlinedIcon sx={{ fontSize: 18 }} />}
            label="Buy"
            sx={{
              ...tabItem,
              "&.Mui-selected": { color: "#16a34a", opacity: 1 },
            }}
          />
          <Tab
            iconPosition="start"
            icon={<TrendingDownOutlinedIcon sx={{ fontSize: 18 }} />}
            label="Sell"
            sx={{
              ...tabItem,
              "&.Mui-selected": { color: "#ef4444", opacity: 1 },
            }}
          />
        </Tabs>

        {/* Currency strip */}
        <Box sx={currencyStrip}>
          {visibleCurrencies.map((curr) => (
            <Box
              key={curr.currencyCode}
              onClick={() => setSelectedFiatCurrency(curr.currencyCode)}
              sx={{
                ...currencyChip,
                backgroundColor:
                  selectedFiatCurrency === curr.currencyCode
                    ? btncolor
                    : "transparent",
                color:
                  selectedFiatCurrency === curr.currencyCode
                    ? "#fff"
                    : "var(--text-color)",
                opacity: selectedFiatCurrency === curr.currencyCode ? 1 : 0.65,
              }}
            >
              {curr.currencyCode}
            </Box>
          ))}

          <IconButton
            onClick={handleDropdownClick}
            size="small"
            sx={moreBtn}
          >
            <ArrowDropDownIcon sx={{ fontSize: 18 }} />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleDropdownClose}
            PaperProps={{
              sx: {
                backgroundColor: "var(--popupbody-color)",
                border: "1px solid rgba(125,125,125,0.15)",
                borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
              },
            }}
          >
            {hiddenCurrencies.map((curr) => (
              <MenuItem
                key={curr.currencyCode}
                onClick={() => handleHiddenCurrencyClick(curr)}
                sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}
              >
                {curr.currencyCode}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Box>

      {/* ── Filter Section ── */}
      <Box sx={{ px: { xs: 2, md: 3 }, pt: 2.5 }}>
        <Box sx={filterCard}>
          <Box sx={filterHeader}>
            <FilterAltOutlinedIcon sx={{ ...filterHeaderIcon, color: btncolor }} />
            <Typography sx={filterHeaderText}>Filter Orders</Typography>
          </Box>
          <Box sx={filterGrid}>
            {/* Amount */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Amount</Typography>
              <TextField
                fullWidth
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                sx={modernFieldStyle}
              />
            </Box>

            {/* Currency */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Currency</Typography>
              <TextField
                select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="All Currencies">All Currencies</MenuItem>
                {allFiatList.map((curr, index) => (
                  <MenuItem key={index} value={curr}>
                    {curr}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Payment Method */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Payment Method</Typography>
              <TextField
                select
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="All Payment Methods">All Payment Methods</MenuItem>
                <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                <MenuItem value="Wallet Service">Wallet Service</MenuItem>
              </TextField>
            </Box>

            {/* Region */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Region</Typography>
              <TextField
                select
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="All Regions">All Regions</MenuItem>
                {regionList.map((r, index) => (
                  <MenuItem key={index} value={r.countryName}>
                    {r.countryName}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Sort */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>Sort By</Typography>
              <TextField
                select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="0">Price: Low to High</MenuItem>
                <MenuItem value="1">Price: High to Low</MenuItem>
                <MenuItem value="2">Number of Trades</MenuItem>
                <MenuItem value="3">Completion Rate</MenuItem>
              </TextField>
            </Box>

            {/* Actions */}
            <Box sx={filterActionsWrap}>
              <Tooltip title="Search" arrow>
                <Box
                  onClick={handleSearch}
                  sx={{
                    ...filterActionBtn,
                    backgroundColor: btncolor,
                    "&:hover": { backgroundColor: btncolor, opacity: 0.88 },
                  }}
                >
                  <SearchIcon sx={{ fontSize: 18 }} />
                </Box>
              </Tooltip>
              <Tooltip title="Reset" arrow>
                <Box
                  onClick={handleReset}
                  sx={{
                    ...filterActionBtn,
                    backgroundColor: "rgba(125,125,125,0.15)",
                    color: "var(--text-color)",
                    "&:hover": { backgroundColor: "rgba(125,125,125,0.25)" },
                  }}
                >
                  <RestartAltIcon sx={{ fontSize: 18 }} />
                </Box>
              </Tooltip>
            </Box>
          </Box>
        </Box>

        {/* ── Results Table ── */}
        <Box sx={resultsBlock}>
          <Box sx={resultsHeader}>
            <Typography sx={resultsTitle}>
              {orderType === "BUY" ? "Buy Orders" : "Sell Orders"}
            </Typography>
            <Typography sx={resultsCaption}>
              {buyOrders.filter((r) => r?.onlineOfflineStatus === 1).length} ads available
            </Typography>
          </Box>

          <TableContainer component={Paper} sx={modernTableContainer}>
            <Table sx={tableStyle}>
              <TableHead>
                <TableRow sx={modernTableHeadRow}>
                  {["Advertiser", "Price", "Availability / Limit", "Payment Method", "Trade"].map(
                    (h, i) => (
                      <TableCell key={i} sx={modernTableHeadCell}>
                        {h}
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {adsloading ? (
                  [...Array(5)].map((_, idx) => (
                    <TableRow key={idx}>
                      {Array(5)
                        .fill()
                        .map((_, i) => (
                          <TableCell key={i}>
                            <Skeleton variant="text" sx={{ bgcolor: "rgba(125,125,125,0.1)" }} />
                          </TableCell>
                        ))}
                    </TableRow>
                  ))
                ) : buyOrders.filter((r) => r?.onlineOfflineStatus === 1).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} sx={emptyCell}>
                      <InboxOutlinedIcon sx={emptyIcon} />
                      <Typography sx={emptyText}>No ads available</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  buyOrders.map(
                    (row, idx) =>
                      row?.onlineOfflineStatus === 1 && (
                        <TableRow key={idx} sx={modernTableBodyRow}>
                          {/* Advertiser */}
                          <TableCell sx={modernTableBodyCell}>
                            <Box display="flex" alignItems="center" gap={1.25}>
                              <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                variant="dot"
                                sx={{
                                  "& .MuiBadge-dot": {
                                    backgroundColor: checkOnlineUser(row?.userId)
                                      ? "#16a34a"
                                      : "rgba(125,125,125,0.5)",
                                    border: "1.5px solid var(--body-color-less)",
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                  },
                                }}
                              >
                                <Avatar
                                  src={row.profileImageLink}
                                  sx={{ width: 36, height: 36, fontSize: "0.85rem" }}
                                  alt={row.firstLetter}
                                />
                              </Badge>
                              <Box
                                sx={{ cursor: "pointer" }}
                                onClick={() => gotoPublicProfile(row)}
                              >
                                <Typography sx={advertiserName}>{row.nickName}</Typography>
                                <Typography sx={advertiserStats}>
                                  {row.recordCount} orders &bull; {row.completionRate}% completion
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          {/* Price */}
                          <TableCell sx={modernTableBodyCell}>
                            <Typography sx={priceText}>
                              {row.price}{" "}
                              <span style={{ fontSize: "0.72rem", opacity: 0.6, fontWeight: 400 }}>
                                {row.fiat}
                              </span>
                            </Typography>
                          </TableCell>

                          {/* Availability */}
                          <TableCell sx={modernTableBodyCell}>
                            <Typography sx={availText}>
                              {row.remainingAmount}{" "}
                              <span style={{ opacity: 0.55 }}>{row.crypto}</span>
                            </Typography>
                            <Typography sx={limitText}>
                              {row.fiat} {row.minOrderLimit} – {row.fiat} {row.maxOrderLimit}
                            </Typography>
                          </TableCell>

                          {/* Payment */}
                          <TableCell sx={modernTableBodyCell}>
                            <Box display="flex" flexWrap="wrap" gap={0.5}>
                              {row.paymentProviderNames.map(
                                (m, i) =>
                                  m !== "" && (
                                    <Chip
                                      key={i}
                                      label={m}
                                      size="small"
                                      sx={{
                                        backgroundColor: alpha(btncolor || "#1976d2", 0.12),
                                        color: btncolor,
                                        fontWeight: 600,
                                        fontSize: "0.68rem",
                                        border: `1px solid ${alpha(btncolor || "#1976d2", 0.25)}`,
                                      }}
                                    />
                                  )
                              )}
                            </Box>
                          </TableCell>

                          {/* Trade Button */}
                          <TableCell sx={modernTableBodyCell}>
                            {row.totalHoldings > holdingInUsd ? (
                              <Button
                                variant="contained"
                                disabled
                                sx={{
                                  ...tradeBtn,
                                  backgroundColor:
                                    orderType === "BUY" ? "#16a34a" : "#ef4444",
                                  opacity: 0.45,
                                }}
                              >
                                Limited
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                onClick={() => buySellCrypto(row)}
                                sx={{
                                  ...tradeBtn,
                                  backgroundColor:
                                    orderType === "BUY" ? "#16a34a" : "#ef4444",
                                  "&:hover": {
                                    backgroundColor:
                                      orderType === "BUY" ? "#15803d" : "#dc2626",
                                  },
                                }}
                              >
                                {orderType === "BUY" ? "Buy" : "Sell"} {selectedFiatCurrency}
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* ── BUY Dialog ── */}
      <Dialog
        open={buyDialogOpen}
        onClose={handleBuyDialogClose}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Buy {selectedFiatCurrency}
          <Box
            component="span"
            onClick={handleBuyDialogClose}
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </Box>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          <Grid
            container
            spacing={3}
            mt={0}
            display="flex"
            justifyContent="space-between"
          >
            {/* Seller Info */}
            <Grid size={{ xs: 12, md: 5 }} sx={{ display: "flex" }}>
              <Box sx={dialogInfoCard}>
                <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
                  <Avatar sx={{ width: 40, height: 40, fontSize: "1rem" }}>
                    {profileName?.charAt(0).toUpperCase()}
                  </Avatar>
                  <Box>
                    <Typography sx={dialogProfileName}>{profileName}</Typography>
                    <Typography sx={dialogProfileStats}>
                      {recordCount} orders &bull; {completionRate}% Completion
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 1.5 }} />

                {[
                  { label: "Price", value: `${Number(price)?.toFixed(6)} ${fiat}`, valueColor: "#16a34a" },
                  { label: "Available", value: `${availableAmount} ${crypto}` },
                  { label: "Payment Time Limit", value: `${paymentTimeLimit} mins` },
                ].map((item, i) => (
                  <Box key={i} display="flex" justifyContent="space-between" mb={1}>
                    <Typography sx={dialogInfoLabel}>{item.label}</Typography>
                    <Typography sx={{ ...dialogInfoValue, color: item.valueColor || "var(--text-color)" }}>
                      {item.value}
                    </Typography>
                  </Box>
                ))}

                <Box display="flex" flexWrap="wrap" gap={0.5} mt={1.5}>
                  {paymentProviderName.map((m, i) => (
                    <Chip
                      key={i}
                      label={m}
                      size="small"
                      sx={{ backgroundColor: "rgba(125,125,125,0.1)", color: "var(--text-color)", fontSize: "0.72rem" }}
                    />
                  ))}
                </Box>

                <Typography sx={{ ...dialogInfoLabel, mt: 2, mb: 0.5 }}>
                  Advertiser's Terms
                </Typography>
                <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)", opacity: 0.7, lineHeight: 1.6 }}>
                  {remarks}
                </Typography>
              </Box>
            </Grid>

            {/* Buy Form */}
            <Grid size={{ xs: 12, md: 5 }} sx={{ display: "flex" }}>
              <Box sx={{ ...dialogInfoCard, flex: 1 }}>
                <Typography sx={formFieldLabel}>I want to pay</Typography>
                <TextField
                  fullWidth
                  type="number"
                  placeholder={`${minOrderLimit} – ${maxOrderLimit}`}
                  value={payAmount}
                  onChange={(e) => calculateTotalAmount(e.target.value)}
                  error={payAmount < minOrderLimit || payAmount > maxOrderLimit}
                  helperText={
                    payAmount < minOrderLimit || payAmount > maxOrderLimit
                      ? `Amount must be between ${minOrderLimit} and ${maxOrderLimit}`
                      : ""
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography sx={adornText}>{fiat}</Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ ...modernFieldStyle, mb: 2 }}
                />

                <Typography sx={formFieldLabel}>I will receive</Typography>
                <TextField
                  fullWidth
                  value={receiveAmount}
                  onChange={(e) => calculateAmount(e.target.value)}
                  placeholder={crypto}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography sx={adornText}>{crypto}</Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={modernFieldStyle}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2.5, backgroundColor: "var(--popupbody-color)", gap: 1 }}>
          <OutlinedButton
            onClick={handleBuyDialogClose}
            variant="outlined"
            sx={dialogOutlineBtn}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            onClick={() => handleBuySellSubmit(orderType)}
            variant="contained"
            disabled={payAmount < minOrderLimit || payAmount > maxOrderLimit}
            sx={dialogBuyBtn}
          >
            Buy {crypto}
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* ── SELL Dialog ── */}
      <Dialog
        open={sellDialogOpen}
        onClose={handleSellDialogClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Sell {selectedFiatCurrency}
          <Box
            component="span"
            onClick={handleSellDialogClose}
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </Box>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          <Grid
            container
            spacing={3}
            mt={0}
            display="flex"
            justifyContent="space-around"
          >
            {/* Seller Info */}
            <Grid size={{ xs: 12, md: 5 }} sx={{ display: "flex" }}>
              <Box sx={dialogInfoCard}>
                <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
                  <Avatar src="/avatar.png" alt="Seller" sx={{ width: 40, height: 40 }} />
                  <Box>
                    <Typography sx={dialogProfileName}>{profileName}</Typography>
                    <Typography sx={dialogProfileStats}>
                      {recordCount} orders &bull; {completionRate}% Completion
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ borderColor: "rgba(125,125,125,0.12)", my: 1.5 }} />

                {[
                  { label: "Price", value: `${Number(price)?.toFixed(6)} ${fiat}`, valueColor: "#16a34a" },
                  { label: "Available", value: `${availableAmount} ${crypto}` },
                  { label: "Payment Time Limit", value: `${paymentTimeLimit} mins` },
                ].map((item, i) => (
                  <Box key={i} display="flex" justifyContent="space-between" mb={1}>
                    <Typography sx={dialogInfoLabel}>{item.label}</Typography>
                    <Typography sx={{ ...dialogInfoValue, color: item.valueColor || "var(--text-color)" }}>
                      {item.value}
                    </Typography>
                  </Box>
                ))}

                <Box display="flex" flexWrap="wrap" gap={0.5} mt={1.5}>
                  {paymentProviderName.map((m, i) => (
                    <Chip
                      key={i}
                      label={m}
                      size="small"
                      sx={{ backgroundColor: "rgba(125,125,125,0.1)", color: "var(--text-color)", fontSize: "0.72rem" }}
                    />
                  ))}
                </Box>

                <Typography sx={{ ...dialogInfoLabel, mt: 2, mb: 0.5 }}>
                  Advertiser's Terms
                </Typography>
                <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)", opacity: 0.7, lineHeight: 1.6 }}>
                  {remarks}
                </Typography>
              </Box>
            </Grid>

            {/* Sell Form + Payment Methods */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
              <Box sx={{ ...dialogInfoCard, flex: 1 }}>
                <Typography sx={formFieldLabel}>I will receive</Typography>
                <TextField
                  fullWidth
                  type="number"
                  placeholder={`${minOrderLimit} – ${maxOrderLimit}`}
                  value={payAmount}
                  onChange={(e) => calculateTotalAmount(e.target.value)}
                  error={payAmount < minOrderLimit || payAmount > maxOrderLimit}
                  helperText={
                    payAmount < minOrderLimit || payAmount > maxOrderLimit
                      ? `Amount must be between ${minOrderLimit} and ${maxOrderLimit}`
                      : ""
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography sx={adornText}>{fiat}</Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ ...modernFieldStyle, mb: 2 }}
                />

                <Typography sx={formFieldLabel}>I want to sell</Typography>
                <TextField
                  fullWidth
                  placeholder={crypto}
                  value={receiveAmount}
                  onChange={(e) => calculateAmount(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography sx={adornText}>{crypto}</Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ ...modernFieldStyle, mb: 2 }}
                />

                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography sx={dialogInfoLabel}>
                    Available: <span style={{ color: "var(--text-color)", fontWeight: 600 }}>{walletAvailableBalance}</span>
                  </Typography>
                </Box>

                {/* Bank Transfer Table */}
                <Typography sx={{ ...sectionLabel, mb: 1 }}>Bank Transfer Methods</Typography>
                <TableContainer sx={miniTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {["Account Holder's Name", "Bank Name", "Action"].map((h, i) => (
                          <TableCell key={i} sx={{ ...modernTableHeadCell, py: 1.25 }}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {bankTransferPaymentMethodList?.length !== 0 ? (
                        bankTransferPaymentMethodList.map((row, idx) => (
                          <TableRow key={idx} sx={modernTableBodyRow}>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() => addBankPaymentMethod(idx)}
                                    sx={{ color: "rgba(125,125,125,0.4)", "&.Mui-checked": { color: btncolor } }}
                                    size="small"
                                  />
                                }
                                label={<Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>{row.accountHolderName}</Typography>}
                              />
                            </TableCell>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>{row.bankName}</TableCell>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>
                              <IconButton
                                size="small"
                                onClick={() => handleOpenEditPaymentModal(row.pmDetailsId, idx, "bank_transfer_services")}
                                sx={{ color: "var(--text-color)", opacity: 0.6 }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} sx={{ textAlign: "center", py: 2, color: "var(--text-color)", opacity: 0.5, fontSize: "0.82rem" }}>
                            No Bank Added
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Wallet Table */}
                <Typography sx={{ ...sectionLabel, mt: 2, mb: 1 }}>Wallet Services</Typography>
                <TableContainer sx={miniTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {["Payment Provider Name", "Wallet ID", "Action"].map((h, i) => (
                          <TableCell key={i} sx={{ ...modernTableHeadCell, py: 1.25 }}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {walletServicePaymentMethodList?.length !== 0 ? (
                        walletServicePaymentMethodList.map((row, idx) => (
                          <TableRow key={idx} sx={modernTableBodyRow}>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() => addWalletPaymentMethod(idx)}
                                    sx={{ color: "rgba(125,125,125,0.4)", "&.Mui-checked": { color: btncolor } }}
                                    size="small"
                                  />
                                }
                                label={<Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>{row.paymentProviderName}</Typography>}
                              />
                            </TableCell>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>{row.walletId}</TableCell>
                            <TableCell sx={{ ...modernTableBodyCell, py: 1 }}>
                              <IconButton
                                size="small"
                                onClick={() => handleOpenEditPaymentModal(row.pmDetailsId, idx, "wallet_services")}
                                sx={{ color: "var(--text-color)", opacity: 0.6 }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} sx={{ textAlign: "center", py: 2, color: "var(--text-color)", opacity: 0.5, fontSize: "0.82rem" }}>
                            No Wallet Service Added
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ px: 3, pb: 2.5, pt: 2, backgroundColor: "var(--popupbody-color)", gap: 1 }}>
          <OutlinedButton
            onClick={handleSellDialogClose}
            variant="outlined"
            sx={dialogOutlineBtn}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            onClick={() => handleBuySellSubmit(orderType)}
            variant="contained"
            disabled={payAmount < minOrderLimit || payAmount > maxOrderLimit}
            sx={{ ...dialogBuyBtn, backgroundColor: "#ef4444", "&:hover": { backgroundColor: "#dc2626" } }}
          >
            Sell {crypto}
          </ContainedButton>
        </DialogActions>
      </Dialog>

      {/* ── Payment Edit Dialog ── */}
      <Dialog
        open={paymentEditModal}
        onClose={handlePaymentEditDialogClose}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >

        <DialogTitle sx={dialogTitleStyle}>
          {editPaymentMethod === "Wallet Services"
            ? "Update Wallet Payment Method"
            : "Update Bank Transfer Payment Method"}
          <Box component="span" onClick={handlePaymentEditDialogClose} sx={dialogCloseBtn}>
            <CloseIcon fontSize="small" />
          </Box>
        </DialogTitle>
        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />

        <DialogContent sx={dialogContentStyle}>
          {editPaymentMethod === "Wallet Services" ? (
            <Grid container spacing={2} mt={0}>
              <Grid size={12}>
                <Typography sx={formFieldLabel}>Payment Provider Name</Typography>
                <TextField
                  name="payment_provider_name"
                  value={paymentProviderNameEdit}
                  onChange={(e) => setPaymentProviderNameEdit(e.target.value)}
                  fullWidth
                  required
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={4}>
                <Typography sx={formFieldLabel}>Phone Number</Typography>
                <TextField
                  name="phone_number"
                  value={phoneNumberEdit}
                  onChange={(e) => setPhoneNumberEdit(e.target.value)}
                  fullWidth
                  required
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={4}>
                <Typography sx={formFieldLabel}>Wallet ID</Typography>
                <TextField
                  name="wallet_id"
                  value={walletIdEdit}
                  onChange={(e) => setWalletIdEdit(e.target.value)}
                  fullWidth
                  required
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={4}>
                <Typography sx={formFieldLabel}>Email ID</Typography>
                <TextField
                  name="email_id"
                  value={emailIdEdit}
                  onChange={(e) => setEmailIdEdit(e.target.value)}
                  fullWidth
                  required
                  sx={modernFieldStyle}
                />
              </Grid>
            </Grid>
          ) : (
            <Box component="form" noValidate>
              <Grid container spacing={2} mt={0}>
                <Grid size={6}>
                  <Typography sx={formFieldLabel}>Account Holder's Name</Typography>
                  <TextField
                    fullWidth
                    {...register("accountHolder", {
                      required: "Required",
                      pattern: { value: /^[A-Za-z\s]+$/, message: "Only alphabets and spaces are allowed" },
                      maxLength: { value: 40, message: "Maximum 40 characters allowed" },
                    })}
                    error={!!errors.accountHolder}
                    helperText={errors.accountHolder?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
                <Grid size={6}>
                  <Typography sx={formFieldLabel}>IBAN / Account Number</Typography>
                  <TextField
                    fullWidth
                    {...register("ibanNumber", {
                      required: "Required",
                      pattern: { value: /^[a-zA-Z0-9\s]+$/, message: "Letters and numbers are allowed" },
                      maxLength: { value: 40, message: "Maximum 40 characters allowed" },
                    })}
                    error={!!errors.ibanNumber}
                    helperText={errors.ibanNumber?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
                <Grid size={6}>
                  <Typography sx={formFieldLabel}>Account Type</Typography>
                  <TextField
                    select
                    fullWidth
                    {...register("accountType", { required: "Required" })}
                    value={selectedAccountType}
                    onChange={(e) => setSelectedAccountType(e.target.value)}
                    sx={modernFieldStyle}
                  >
                    <MenuItem value="Personal Savings">Personal Savings</MenuItem>
                    <MenuItem value="Personal Checking">Personal Checking</MenuItem>
                    <MenuItem value="Business Savings">Business Savings</MenuItem>
                    <MenuItem value="Business Checking">Business Checking</MenuItem>
                  </TextField>
                </Grid>
                <Grid size={3}>
                  <Typography sx={formFieldLabel}>Code Type</Typography>
                  <TextField
                    select
                    fullWidth
                    {...register("codeType", { required: "Required" })}
                    value={selectedCodeType}
                    onChange={(e) => setSelectedCodeType(e.target.value)}
                    sx={modernFieldStyle}
                  >
                    <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                    <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                    <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                  </TextField>
                </Grid>
                <Grid size={3}>
                  <Typography sx={formFieldLabel}>Enter Code</Typography>
                  <TextField
                    fullWidth
                    {...register("additionalCode")}
                    error={!!errors.additionalCode}
                    helperText={errors.additionalCode?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
                <Grid size={6}>
                  <Typography sx={formFieldLabel}>Bank Name</Typography>
                  <TextField
                    fullWidth
                    {...register("bankName", {
                      required: "Required",
                      pattern: { value: /^[a-zA-Z0-9\s]+$/, message: "Letters and numbers are allowed" },
                      maxLength: { value: 50, message: "Maximum 50 characters allowed" },
                    })}
                    error={!!errors.bankName}
                    helperText={errors.bankName?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
                <Grid size={6}>
                  <Typography sx={formFieldLabel}>Bank Address</Typography>
                  <TextField
                    fullWidth
                    {...register("bankAddress", {
                      required: "Required",
                      pattern: { value: /^[a-zA-Z0-9,\-\s\/]+$/, message: "Letters, numbers, commas, and hyphens are allowed" },
                      maxLength: { value: 200, message: "Maximum 200 characters allowed" },
                    })}
                    error={!!errors.bankAddress}
                    helperText={errors.bankAddress?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={{ p: 2.5, backgroundColor: "var(--popupbody-color)", gap: 1 }}>
          <OutlinedButton
            onClick={() => setPaymentEditModal(false)}
            variant="outlined"
            sx={dialogOutlineBtn}
          >
            Cancel
          </OutlinedButton>
          {editPaymentMethod === "Wallet Services" ? (
            <ContainedButton variant="contained" onClick={() => updateWalletDetails()} sx={dialogBuyBtn}>
              Save Changes
            </ContainedButton>
          ) : (
            <ContainedButton variant="contained" onClick={() => updateBankDetails()} sx={dialogBuyBtn}>
              Save Changes
            </ContainedButton>
          )}
        </DialogActions>
      </Dialog>
      </Box>{/* end mainCard */}
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
  pb: 3,
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1,
  minHeight: 56,
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
};

const currencyStrip = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  flexWrap: "wrap",
  py: 0.75,
};

const currencyChip = {
  px: 1.5,
  py: 0.5,
  borderRadius: "8px",
  fontSize: "0.78rem",
  fontWeight: 700,
  cursor: "pointer",
  transition: "all 0.15s ease",
  userSelect: "none",
  border: "1px solid rgba(125,125,125,0.2)",
  "&:hover": { opacity: 1 },
};

const moreBtn = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  border: "1px solid rgba(125,125,125,0.2)",
  color: "var(--text-color)",
  opacity: 0.65,
  "&:hover": { opacity: 1, backgroundColor: "rgba(125,125,125,0.1)" },
};

// Filter
const filterCard = {
  borderRadius: "12px",
  mb: 3,
};

const filterHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
};

const filterHeaderIcon = {
  fontSize: 18,
};

const filterHeaderText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const filterGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr 1fr 1fr auto" },
  gap: 2,
  alignItems: "end",
};

const fieldWrap = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
  minWidth: 0,
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};

const modernFieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "var(--text-color)",
    WebkitTextFillColor: "var(--text-color)",
    opacity: 0.5,
  },
};

const filterActionsWrap = {
  display: "flex",
  alignItems: "flex-end",
  gap: 1,
};

const filterActionBtn = {
  width: 48,
  height: 48,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "#fff",
  transition: "opacity 0.15s ease",
  flexShrink: 0,
};

// Results
const resultsBlock = { mt: 0 };

const resultsHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 1.5,
};

const resultsTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const resultsCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
};

// Table
const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 700,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
};

const advertiserName = {
  fontSize: "0.88rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const advertiserStats = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.2,
};

const priceText = {
  fontSize: "0.92rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const availText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const limitText = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.2,
};

const tradeBtn = {
  height: 36,
  px: 2,
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.82rem",
  color: "#fff",
  minWidth: 100,
};

const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.35,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

// Dialogs
const dialogPaper = {
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  overflow: "hidden",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.1rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.55,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  "&:hover": { opacity: 1 },
};

const dialogContentStyle = {
  pt: 2.5,
  pb: 1,
  backgroundColor: "var(--popupbody-color)",
};

const dialogInfoCard = {
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.12)",
  borderRadius: "12px",
  p: 2.5,
  flex: 1,
};

const dialogProfileName = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const dialogProfileStats = {
  fontSize: "0.75rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.25,
};

const dialogInfoLabel = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
  fontWeight: 500,
};

const dialogInfoValue = {
  fontSize: "0.82rem",
  fontWeight: 600,
};

const formFieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mb: 0.75,
};

const adornText = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.5,
};

const sectionLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.55,
};

const miniTableContainer = {
  borderRadius: "10px",
  border: "1px solid rgba(125,125,125,0.13)",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
};

const dialogOutlineBtn = {
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  height: 44,
  minWidth: 100,
  fontSize: "0.88rem",
};

const dialogBuyBtn = {
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  height: 44,
  minWidth: 120,
  fontSize: "0.88rem",
  backgroundColor: "#16a34a",
  color: "#fff",
  "&:hover": { backgroundColor: "#15803d" },
};

export default BuySellOrderTable;
